import { Ban, Loader2 } from 'lucide-react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';

export default function SkipSenderDialog({ open, onOpenChange, email, working, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md" data-testid="skip-sender-confirmation-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif text-2xl tracking-tight">Always skip this sender?</AlertDialogTitle>
          <AlertDialogDescription data-testid="skip-sender-safety-copy">
            Future emails from <strong className="text-foreground break-all">{email?.from_email}</strong> will bypass Needs Action. The current email will move to Skipped. Nothing changes in Apple Mail or Hostinger.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={working} data-testid="cancel-skip-sender-button">Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={working}
            onClick={event => { event.preventDefault(); onConfirm(); }}
            className="rounded-full bg-[#A3503B] text-white hover:bg-[#843F30]"
            data-testid="confirm-skip-sender-button"
          >
            {working ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Ban className="w-4 h-4 mr-1.5" />}
            Always skip sender
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}